import { User, UserCredentials } from '@/models/User';
import api from '../common/api/api';
import Token from '../models/Token';
import UserExtended from '../models/UserExtended';
import TokenService from './TokenService';

export default class UserService {
  public async login(payload: UserCredentials | User): Promise<UserExtended> {
    const response = await api.post('/auth/login', payload);
    const { data } = response.data;
    const { user } = response.data;

    return { tokens: data, user };
  }

  public async refreshToken(payload: Token): Promise<Token> {
    const response = await api.post('/auth/refresh', payload);
    const { data } = response;

    return data;
  }

  public async fetchUsers(): Promise<User[]> {
    const response = await api.get('/users');
    const { data } = response.data;

    return data;
  }

  public async logout(): Promise<void> {
    const tokens: Token | null = TokenService.getToken();
    const ssoLogin: boolean = TokenService.wasSsoLogin();

    if (tokens) {
      TokenService.removeToken();

      try {
        await api.post('/auth/logout', tokens);
      } catch (err: unknown) {
        console.log(err);
      }
    }

    if (ssoLogin) {
      TokenService.clearSsoLogin();

      try {
        await this.logoutSso();
      } catch (err: unknown) {
        console.log(err);
      }
    }
  }

  public async logoutSso(): Promise<void> {
    await api.get('/auth/sso/logout');
  }

  public static async fetchUserData(): Promise<User> {
    const response = await api.get('/auth');
    const { data }: { data: User } = response.data;
    return data;
  }

  // TODO User ma iść do vuexa a nie do localstorage

  // public setUser(user: UserInfo): void {
  //    localStorage.setItem(this.USER_ID, JSON.stringify(user));
  // }

  // public getUser(): UserInfo | null {
  //   return JSON.parse(localStorage.getItem(this.USER_ID)!);
  // }
}
